import type { CSSProperties } from 'react';

import { Circle, Container, SVG } from './styles';

enum ProgressTypes {
  Circular = 'circular',
}

export interface ProgressProps {
  color: string;
  size?: number;
  thickness?: number;
  type?: ProgressTypes;
  style?: CSSProperties;
}

export const Progress = ({
  color,
  size = 44,
  thickness = 3.6,
  style,
}: // TODO: This will be used when we extend this component to support other progress types
// type = ProgressTypes.Circular,
ProgressProps) => (
  <Container role="progressbar" color={color} size={size} style={style}>
    <SVG color={color} data-testid="svg" viewBox={`${size / 2} ${size / 2} ${size} ${size}`}>
      <Circle cx={size} cy={size} fill="none" r={(size - thickness) / 2} size={size} thickness={thickness} />
    </SVG>
  </Container>
);
